import { PermissionArrayType } from '../../../../types/other';
import { getAllPermissionRolesForUserLevel, PERMISSIONROLECONSTANTS } from '../../../../features/utils/utils.action';

export const devicePermissions: PermissionArrayType = {
  CREATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  UPDATE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
  READ: [
    PERMISSIONROLECONSTANTS.superadmin,
    ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin']),
    ...getAllPermissionRolesForUserLevel('reseller', ['owner', 'admin']),
  ],
  DELETE: [PERMISSIONROLECONSTANTS.superadmin, ...getAllPermissionRolesForUserLevel('telcloud', ['admin', 't3_admin'])],
};
